<section class="follow-up" *ngIf="!this.loadingState else this.loading">
  <!-- Regresar -->
  <!-- <a class="follow-up__back" href="#">← Regresar</a> -->

  <!-- Título principal -->
  <h1 i18n>Seguimiento personalizado</h1>

  <!-- Sección introductoria -->
  <section class="follow-up__intro">
    <div class="follow-up__content">
      <div class="follow-up__text">
        <p i18n>
          El acompañamiento personalizado que ofrecemos en Bhavani nace de una visión profunda del bienestar: un proceso
          que requiere no solo claridad técnica, sino también presencia emocional, contención y guía humana.
        </p>
        <p i18n>
          Estas sesiones individuales han sido diseñadas para quienes desean integrar su proceso con mayor profundidad,
          claridad y continuidad.
        </p>
        <p i18n>
          Este servicio es brindado directamente por el coach que has elegido, siempre que cuente con disponibilidad
          para acompañarte en este formato. En caso de que no esté habilitado para ofrecer sesiones de seguimiento,
          podrás elegir entre otros especialistas certificados disponibles.
        </p>
        <p i18n>
          Cada espacio está enfocado en acompañarte de forma cercana en cada etapa de tu camino. Incluye recursos
          prácticos cuidadosamente sugeridos por el especialista, que fortalecen y enriquecen tu experiencia de manera
          coherente, consciente y transformadora.
        </p>

        <h2 i18n>¿Qué incluye este servicio?</h2>
        <ul>
          <li i18n>Acompañamiento individual con especialistas certificados en microdosis</li>
          <li i18n>Espacios para ajustar tu protocolo, resolver dudas y recibir orientación personalizada</li>
          <li i18n>Profundizar en tu experiencia emocional, física y mental</li>
          <li i18n>Recomendaciones de herramientas simples que fortalezcan la integración de tu protocolo y favorezcan
            la
            continuidad del proceso (según tus necesidades y momento personal)</li>
          <li i18n>Modalidad flexible: semanal, quincenal, mensual o según tu necesidad</li>
          <li i18n>Puedes elegir desde una sesión puntual hasta un plan con mayor continuidad</li>
        </ul>

        <h2 i18n>¿Qué es un Coach BHAVANI?</h2>
        <p i18n>
          Un Coach BHAVANI es un especialista que representa los valores, la misión y la visión de nuestra comunidad, y
          acompaña cada proceso desde una profunda coherencia humana y profesional.
        </p>
        <p i18n>
          Cada uno ha sido cuidadosamente seleccionado y cuenta con una trayectoria sólida en el ámbito del bienestar,
          la salud integrativa y el desarrollo humano, lo que les permite ofrecer un acompañamiento sensible, informado
          y con alto criterio profesional.
        </p>
        <p i18n>
          Su forma de acompañar se basa en la presencia, la ética y la creación de un espacio de confianza que favorece
          la reflexión, la integración y el crecimiento personal en cada etapa del proceso.
        </p>
      </div>

      <div class="follow-up__image">
        <img src="assets/images/coachfollowup.png" alt="Coach escribiendo en libreta" />
        <div class="follow-up__notice">
          <strong i18n>AVISO IMPORTANTE</strong>
          <p i18n>Este servicio no tiene un enfoque clínico ni terapéutico. Es un acompañamiento profesional que
            complementa
            tu protocolo con microdosis desde una mirada integral.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección planes -->
  <section class="follow-up__plans" *ngIf="followUpPlans.plans.length > 0 else this.noPlans ">
    <h2 i18n>Elige tu plan de seguimiento</h2>
    <p i18n>
      Explora las opciones disponibles y selecciona el plan que mejor se ajuste a tu camino. <br />
      Lo que varía es la frecuencia del contacto y la continuidad del apoyo, según tus necesidades, ritmo y momento
      personal.
    </p>

    <p i18n><strong>{{coach?.name}} {{coach?.lastname}}</strong>, coach certificado de Bhavani, ha diseñado estos planes
      de seguimiento para acompañarte en cada etapa de tu proceso:</p>
    <div class="follow-up__plan-cards">
      <ng-container *ngFor="let plan of followUpPlans.plans">
        <div class="plan-card">
          <small>{{ locale === 'en' && plan?.intro_en ? plan?.intro_en : plan?.intro }}</small>
          <h3>{{ locale === 'en' && plan?.name_en ? plan?.name_en : plan?.name }}</h3>
          <p class="price">{{formatCurrency(plan?.price / 100)}} {{plan?.prices?.currency?.toUpperCase()}}</p>
          <p><strong>{{ locale === 'en' && plan?.sub_heading_en ? plan?.sub_heading_en : plan?.sub_heading }}</strong></p>
          <p>{{ locale === 'en' && plan?.description_en ? plan?.description_en : plan?.description }}</p>
          <button (click)="buyPlan(plan.buy_plan_path)" i18n>Seleccionar plan y agendar</button>
        </div>
      </ng-container>
    </div>
    <p class="plan-card--moreOptions" i18n>Si quieres conocer otros especialistas disponibles para acompañarte en tu
      seguimiento, <a [routerLink]="'/platform/follow-up/specialists'">haz clic aquí</a></p>
    <div class="follow-up__plan-cards">
      <div class="plan-card plan-card--full">
        <h3 i18n>¿Necesitas un espacio más profundo y terapéutico?</h3>
        <p i18n><strong>Además del acompañamiento, algunos de nuestros especialistas también ofrecen procesos de terapia
            individual.</strong></p>
        <p i18n>
          Si deseas explorar con mayor profundidad, sanar heridas emocionales o atravesar un proceso terapéutico, puedes
          acceder a sesiones personalizadas dentro de otro enfoque.
        </p>
        <a [routerLink]="'/platform/therapists/.'" i18n>Conocer terapeutas y reservar sesión →</a>
      </div>
    </div>
  </section>
</section>


<ng-template #noPlans>
  <div class="dakkini-card texture_secondary mt-4" style="color: white">
    <p class="text-center bold mt-4" i18n><strong>Por el momento este especialista no tiene planes de seguimiento
        disponibles.</strong></p>
    <p class="my-4 plan-card--moreOptions" i18n>Si quieres conocer otros especialistas disponibles para acompañarte en
      tu seguimiento, <a [routerLink]="'/platform/follow-up/specialists'">haz clic aquí</a></p>
  </div>
  <div class="follow-up__plan-cards mt-4">
    <div class="plan-card plan-card--full">
      <h3 i18n>¿Necesitas un espacio más profundo y terapéutico?</h3>
      <p i18n><strong>Además del acompañamiento, algunos de nuestros especialistas también ofrecen procesos de terapia
          individual.</strong></p>
      <p i18n>
        Si deseas explorar con mayor profundidad, sanar heridas emocionales o atravesar un proceso terapéutico, puedes
        acceder a sesiones personalizadas dentro de otro enfoque.
      </p>
      <a [routerLink]="'/platform/therapists/.'" i18n>Conocer terapeutas y reservar sesión →</a>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <loading-dots-component></loading-dots-component>
</ng-template>